import { formatDateToYYYYMMDDhhmmss } from "@/common/util/date-util";
import { Body14Regular } from "@/components/typography/Body14Regular";
import { HistoryDto } from "@/types/dto/history-dto";
import { Table } from "flowbite-react";
import { CustomCell } from "../CustomCell";

interface Props {
  data: HistoryDto;
}

export const AdminOrderStatusRow: React.FC<Props> = ({ data }) => {
  return (
    <Table.Row key={data.id} className="bg-primary-white">
      <Table.Cell>
        <CustomCell>
          <Body14Regular className="text-semantic-text-body">
            {formatDateToYYYYMMDDhhmmss(new Date(data.modifiedAt))}
          </Body14Regular>
        </CustomCell>
      </Table.Cell>
      <Table.Cell>
        <CustomCell>
          <Body14Regular className="text-semantic-text-body">
            {data.after}
          </Body14Regular>
        </CustomCell>
      </Table.Cell>
      <Table.Cell>
        <CustomCell>
          <Body14Regular className="text-semantic-text-tertiary">
            {data.before}
          </Body14Regular>
        </CustomCell>
      </Table.Cell>
      <Table.Cell>
        <CustomCell>
          <Body14Regular className="text-semantic-text-body">
            {data.modifiedBy}
          </Body14Regular>
        </CustomCell>
      </Table.Cell>
    </Table.Row>
  );
};
